
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

export class JRECommand extends Poker2Command {
    protected get cmdId(): string {
        return "jre";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            Poker2Model.tournamentData.parse_JRE(paramObj);

            // update tournament details view (only in tournament lobby)
            if (Poker2LayoutManager.getInstance().currentState == 14) {
                var paramObject: any = { id: paramObj.id, update: true };
                BasicModel.smartfoxClient.sendMessage("jio", [JSON.stringify(paramObject)]);
            }
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
